export { default } from './ExpandableArea';
